
/* eslint-disable */
import { ArtistTrackModel } from '@/models'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class GenreTracks extends Vue {
    loader = true
    sourceTracks: ArtistTrackModel[] = []

    get radioSource() {
        return this.$store.getters['getRadioSource']
    }

    get tracks () {
        if (this.radioSource === 'audius' || this.radioSource === 'suno') {
            return this.sourceTracks
        }
        return this.$store.getters['trackModule/getTopTracks'] ? this.$store.getters['trackModule/getTopTracks'] : []
    }

    get audio () {
        return this.$store.getters['getAudio']
    }

    get current () {
        return this.$store.getters['getCurrent']
    }

    convertTime (secs: number | string) {
        const totalSec = Math.floor(Number(secs) || 0);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }

    playSong (track: ArtistTrackModel, queue: ArtistTrackModel[]) {
        this.audio.playbackRate = 1
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', queue)
        this.$store.commit('playTrack', track)
        this.audio.play();
    }

    async loadContent() {
        this.loader = true
        window.scrollTo(0,0);
        if (this.radioSource === 'audius') {
            this.sourceTracks = await this.$store.dispatch('audiusModule/fetchRadioTracks', { limit: 40 })
        } else if (this.radioSource === 'suno') {
            this.sourceTracks = await this.$store.dispatch('sunoModule/fetchRadioTracks', { limit: 40 })
        } else {
            await this.$store.dispatch('trackModule/fetchTopTracks', 40)
        }
        this.loader = false
    }

    mounted () {
        this.loadContent()
        this.$store.watch(
            (state: any) => state.radioSource,
            () => { this.loadContent() }
        )
    }
}
